import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  HostListener,
  OnChanges,
  SimpleChanges,
  OnInit,
  ChangeDetectionStrategy,
  ElementRef,
} from '@angular/core';
import { cloneDeep, isNil } from 'lodash';

import { DropdownSelection } from './dropdown-output.model';
import { DropdownItem } from 'OpsCenter/shared/components/dropdown-menu/dropdown-item.model';

@Component({
  selector: 'app-dropdown-menu',
  template: require('./dropdown-menu.component.html'),
  styles: [require('./dropdown-menu.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent implements OnInit, OnChanges {
  @ViewChild('dropdown', { read: ElementRef, static: false }) dropdown;
  @Input() searchBy: string;
  @Input() isLoading: boolean;
  @Input() items: any[];
  @Input() searchInput: string;
  @Input() resultTemplate: TemplateRef<any>;

  @Output() selected = new EventEmitter<DropdownSelection>();
  @Output() dropdownHidden = new EventEmitter<object | void>();

  originalItems: DropdownItem[];
  activeItem = null;
  activeItemIndex = -1;

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowDown':
        this.onArrowDown();
        break;
      case 'ArrowUp':
        this.onArrowUp();
        break;
      case 'Enter':
        this.onEnter();
        break;
    }
  }

  ngOnInit() {
    this.originalItems = cloneDeep(this.items);
  }

  ngOnChanges(changes: SimpleChanges) {
    const { searchInput, defaultFilter } = changes;

    if ((searchInput && !isNil(searchInput.currentValue)) || (defaultFilter && !isNil(defaultFilter.currentValue))) {
      this.filterItems();
      this.resetActiveItem();
    }
  }

  public trackByIndex(index: number): number {
    return index;
  }

  public filterItems() {
    if (this.originalItems) {
      this.items = cloneDeep(this.originalItems);
    }
  }

  public onDropdownMouseEnter(item, index) {
    this.activeItem = item;
    this.activeItemIndex = index;
  }

  public onItemSelect(item, index) {
    this.selected.emit({ item, index });
    this.resetActiveItem();
  }

  private onArrowDown() {
    if (this.activeItemIndex < this.items.length - 1) {
      this.activeItemIndex++;
      this.activeItem = this.items[this.activeItemIndex];
      this.scrollIntoViewIfNeeded();
    }
  }

  private onArrowUp() {
    if (this.activeItemIndex > -1) {
      this.scrollIntoViewIfNeeded(true);
      this.activeItemIndex--;
      this.activeItem = this.items[this.activeItemIndex];
    } else {
      this.resetActiveItem();
    }
  }

  private scrollIntoViewIfNeeded(scrollUp = false) {
    const dropdown = this.dropdown.nativeElement;
    const { offsetHeight, offsetTop } = dropdown.children[this.activeItemIndex];

    if (!scrollUp && offsetTop >= dropdown.offsetHeight - offsetHeight) {
      dropdown.scrollTop += offsetHeight;
    }

    if (scrollUp && offsetTop - offsetHeight <= dropdown.scrollTop) {
      dropdown.scrollTop -= offsetHeight;
    }
  }

  private onEnter() {
    if (this.activeItem) {
      this.onItemSelect(this.activeItem, this.activeItemIndex);
    }
  }

  public resetActiveItem() {
    this.activeItem = null;
    this.activeItemIndex = -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-menu/dropdown-menu.component.ts